// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================================
   Imergey Admin Panel — Design Tokens
   Brand kit: #071E31 · #3B6B94 · #6CE5E8
   ===================================================================== */

:root {
  /* ---------- Brand (Steel Blue → Midnight Blue) ---------- */
  --brand-50:  #EAF1F6;
  --brand-100: #D2E2EC;
  --brand-200: #A8C5DA;
  --brand-300: #7CA7C2;
  --brand-400: #5A8AAB;
  --brand-500: #3B6B94;   /* Steel Blue */
  --brand-600: #2C5478;
  --brand-700: #1D3C56;
  --brand-800: #122B3F;
  --brand-900: #071E31;   /* Midnight Blue */

  --accent-400: #8FEEF0;
  --accent-500: #6CE5E8;  /* Turquoise */
  --accent-600: #34C2C6;

  --brand-gradient:       linear-gradient(135deg, #3B6B94 0%, #071E31 100%);
  --brand-gradient-hover: linear-gradient(135deg, #4A7CA8 0%, #0D2740 100%);
  --brand-gradient-soft:  linear-gradient(135deg, #EAF1F6 0%, #F2FAFB 100%);

  /* ---------- Neutrals ---------- */
  --n-0:   #FFFFFF;
  --n-50:  #F8FAFC;
  --n-100: #F1F5F9;
  --n-200: #E2E8F0;
  --n-300: #CBD5E1;
  --n-400: #94A3B8;
  --n-500: #64748B;
  --n-600: #475569;
  --n-700: #334155;
  --n-800: #1E293B;
  --n-900: #0F172A;

  /* ---------- Semantic ---------- */
  --success:     #10B981;
  --success-700: #047857;
  --success-bg:  #ECFDF5;
  --error:       #EF4444;
  --error-700:   #B91C1C;
  --error-bg:    #FEF2F2;
  --warning:     #F59E0B;
  --warning-700: #B45309;
  --warning-bg:  #FFFBEB;
  --info:        #3B82F6;
  --info-700:    #1D4ED8;
  --info-bg:     #EFF6FF;

  /* ---------- Surfaces & text ---------- */
  --bg-app:      #F6F7FB;
  --bg-surface:  #FFFFFF;
  --bg-subtle:   #F8FAFC;
  --bg-hover:    #F1F3FB;
  --text-primary:   #0F172A;
  --text-secondary: #475569;
  --text-muted:     #94A3B8;
  --text-on-brand:  #FFFFFF;
  --border:        #E7E9F2;
  --border-strong: #D6DAE8;
  --ring: rgba(59, 107, 148, 0.35);

  /* ---------- Radius ---------- */
  --r-xs: 6px;
  --r-sm: 8px;
  --r-md: 12px;
  --r-lg: 16px;
  --r-xl: 20px;
  --r-2xl: 28px;
  --r-full: 9999px;

  /* ---------- Shadows ---------- */
  --shadow-xs: 0 1px 2px rgba(15, 23, 42, 0.06);
  --shadow-sm: 0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);
  --shadow-md: 0 4px 14px rgba(15, 23, 42, 0.08);
  --shadow-lg: 0 12px 28px -6px rgba(15, 23, 42, 0.14);
  --shadow-xl: 0 24px 48px -12px rgba(15, 23, 42, 0.20);
  --shadow-brand: 0 10px 24px -6px rgba(7, 30, 49, 0.45);

  /* ---------- Typography ---------- */
  --font-sans: 'Greycliff CF', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  --font-display: 'Greycliff CF', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  /* ---------- Spacing (4px scale) ---------- */
  --space-1: 4px;
  --space-2: 8px;
  --space-3: 12px;
  --space-4: 16px;
  --space-5: 20px;
  --space-6: 24px;
  --space-8: 32px;
  --space-10: 40px;
  --space-12: 48px;
  --space-16: 64px;

  --fs-xs:   12px;
  --fs-sm:   13px;
  --fs-base: 14px;
  --fs-md:   15px;
  --fs-lg:   18px;
  --fs-xl:   22px;
  --fs-2xl:  28px;
  --fs-3xl:  36px;

  --lh-tight:  1.2;
  --lh-snug:   1.35;
  --lh-normal: 1.55;

  --fw-regular:   400;
  --fw-medium:    500;
  --fw-semibold:  600;
  --fw-bold:      700;
  --fw-extrabold: 800;

  /* ---------- Motion ---------- */
  --ease-out:    cubic-bezier(0.16, 1, 0.3, 1);
  --ease-in-out: cubic-bezier(0.65, 0, 0.35, 1);
  --ease-spring: cubic-bezier(0.34, 1.56, 0.64, 1);
  --dur-fast: 0.15s;
  --dur-base: 0.25s;
  --dur-slow: 0.4s;

  /* ---------- Z-index ---------- */
  --z-header:  1000;
  --z-sidebar: 1010;
  --z-drawer:  1050;
  --z-modal:   1100;
  --z-toast:   1200;

  /* ---------- Legacy variable remap ---------- */
  --theme1: #0F172A;
  --theme1Dark: #334155;
  --themebtn: #071E31;
  --theme2Dark: #3a3c4b;
  --themeSuccess: #10B981;
  --themeSuccessDark: #047857;
  --themeDanger: #EF4444;
  --themeDangerDark: #B91C1C;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/tokens.css"],"names":[],"mappings":"AAAA;;;0EAG0E;;AAE1E;EACE,6DAA6D;EAC7D,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB,IAAI,eAAe;EACvC,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB,IAAI,kBAAkB;;EAE1C,qBAAqB;EACrB,qBAAqB,GAAG,cAAc;EACtC,qBAAqB;;EAErB,yEAAyE;EACzE,yEAAyE;EACzE,yEAAyE;;EAEzE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,mCAAmC;EACnC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;;EAEtB,0CAA0C;EAC1C,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;EACxB,gCAAgC;;EAEhC,iCAAiC;EACjC,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;;EAEhB,kCAAkC;EAClC,6CAA6C;EAC7C,+EAA+E;EAC/E,8CAA8C;EAC9C,oDAAoD;EACpD,qDAAqD;EACrD,sDAAsD;;EAEtD,qCAAqC;EACrC,uHAAuH;EACvH,yFAAyF;EACzF,8CAA8C;EAC9C,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;;EAEhB,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;EACf,eAAe;;EAEf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;;EAEjB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,iCAAiC;EACjC,4CAA4C;EAC5C,6CAA6C;EAC7C,gDAAgD;EAChD,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;;EAEhB,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,gDAAgD;EAChD,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;EACtB,0BAA0B;AAC5B","sourcesContent":["/* =====================================================================\n   Imergey Admin Panel — Design Tokens\n   Brand kit: #071E31 · #3B6B94 · #6CE5E8\n   ===================================================================== */\n\n:root {\n  /* ---------- Brand (Steel Blue → Midnight Blue) ---------- */\n  --brand-50:  #EAF1F6;\n  --brand-100: #D2E2EC;\n  --brand-200: #A8C5DA;\n  --brand-300: #7CA7C2;\n  --brand-400: #5A8AAB;\n  --brand-500: #3B6B94;   /* Steel Blue */\n  --brand-600: #2C5478;\n  --brand-700: #1D3C56;\n  --brand-800: #122B3F;\n  --brand-900: #071E31;   /* Midnight Blue */\n\n  --accent-400: #8FEEF0;\n  --accent-500: #6CE5E8;  /* Turquoise */\n  --accent-600: #34C2C6;\n\n  --brand-gradient:       linear-gradient(135deg, #3B6B94 0%, #071E31 100%);\n  --brand-gradient-hover: linear-gradient(135deg, #4A7CA8 0%, #0D2740 100%);\n  --brand-gradient-soft:  linear-gradient(135deg, #EAF1F6 0%, #F2FAFB 100%);\n\n  /* ---------- Neutrals ---------- */\n  --n-0:   #FFFFFF;\n  --n-50:  #F8FAFC;\n  --n-100: #F1F5F9;\n  --n-200: #E2E8F0;\n  --n-300: #CBD5E1;\n  --n-400: #94A3B8;\n  --n-500: #64748B;\n  --n-600: #475569;\n  --n-700: #334155;\n  --n-800: #1E293B;\n  --n-900: #0F172A;\n\n  /* ---------- Semantic ---------- */\n  --success:     #10B981;\n  --success-700: #047857;\n  --success-bg:  #ECFDF5;\n  --error:       #EF4444;\n  --error-700:   #B91C1C;\n  --error-bg:    #FEF2F2;\n  --warning:     #F59E0B;\n  --warning-700: #B45309;\n  --warning-bg:  #FFFBEB;\n  --info:        #3B82F6;\n  --info-700:    #1D4ED8;\n  --info-bg:     #EFF6FF;\n\n  /* ---------- Surfaces & text ---------- */\n  --bg-app:      #F6F7FB;\n  --bg-surface:  #FFFFFF;\n  --bg-subtle:   #F8FAFC;\n  --bg-hover:    #F1F3FB;\n  --text-primary:   #0F172A;\n  --text-secondary: #475569;\n  --text-muted:     #94A3B8;\n  --text-on-brand:  #FFFFFF;\n  --border:        #E7E9F2;\n  --border-strong: #D6DAE8;\n  --ring: rgba(59, 107, 148, 0.35);\n\n  /* ---------- Radius ---------- */\n  --r-xs: 6px;\n  --r-sm: 8px;\n  --r-md: 12px;\n  --r-lg: 16px;\n  --r-xl: 20px;\n  --r-2xl: 28px;\n  --r-full: 9999px;\n\n  /* ---------- Shadows ---------- */\n  --shadow-xs: 0 1px 2px rgba(15, 23, 42, 0.06);\n  --shadow-sm: 0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04);\n  --shadow-md: 0 4px 14px rgba(15, 23, 42, 0.08);\n  --shadow-lg: 0 12px 28px -6px rgba(15, 23, 42, 0.14);\n  --shadow-xl: 0 24px 48px -12px rgba(15, 23, 42, 0.20);\n  --shadow-brand: 0 10px 24px -6px rgba(7, 30, 49, 0.45);\n\n  /* ---------- Typography ---------- */\n  --font-sans: 'Greycliff CF', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  --font-display: 'Greycliff CF', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  /* ---------- Spacing (4px scale) ---------- */\n  --space-1: 4px;\n  --space-2: 8px;\n  --space-3: 12px;\n  --space-4: 16px;\n  --space-5: 20px;\n  --space-6: 24px;\n  --space-8: 32px;\n  --space-10: 40px;\n  --space-12: 48px;\n  --space-16: 64px;\n\n  --fs-xs:   12px;\n  --fs-sm:   13px;\n  --fs-base: 14px;\n  --fs-md:   15px;\n  --fs-lg:   18px;\n  --fs-xl:   22px;\n  --fs-2xl:  28px;\n  --fs-3xl:  36px;\n\n  --lh-tight:  1.2;\n  --lh-snug:   1.35;\n  --lh-normal: 1.55;\n\n  --fw-regular:   400;\n  --fw-medium:    500;\n  --fw-semibold:  600;\n  --fw-bold:      700;\n  --fw-extrabold: 800;\n\n  /* ---------- Motion ---------- */\n  --ease-out:    cubic-bezier(0.16, 1, 0.3, 1);\n  --ease-in-out: cubic-bezier(0.65, 0, 0.35, 1);\n  --ease-spring: cubic-bezier(0.34, 1.56, 0.64, 1);\n  --dur-fast: 0.15s;\n  --dur-base: 0.25s;\n  --dur-slow: 0.4s;\n\n  /* ---------- Z-index ---------- */\n  --z-header:  1000;\n  --z-sidebar: 1010;\n  --z-drawer:  1050;\n  --z-modal:   1100;\n  --z-toast:   1200;\n\n  /* ---------- Legacy variable remap ---------- */\n  --theme1: #0F172A;\n  --theme1Dark: #334155;\n  --themebtn: #071E31;\n  --theme2Dark: #3a3c4b;\n  --themeSuccess: #10B981;\n  --themeSuccessDark: #047857;\n  --themeDanger: #EF4444;\n  --themeDangerDark: #B91C1C;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
